export * from "ce/pages/AdminSettings/config/branding/UpgradeBanner";
import { default as CE_UpgradeBanner } from "ce/pages/AdminSettings/config/branding/UpgradeBanner";
export default CE_UpgradeBanner;
